"use strict";

require("regenerator-runtime/runtime");

require("airbnb-js-shims");

require("core-js/features/symbol");